<template>
    <div class="members">
        <h4 v-if="show_title" class="title is-6">Members</h4>

        <team-members-form
            @created="reload"
            :team_id="team_id"/>

        <team-members-list
            @removed="reload"
            :members="list.data.results || []"
            :loading="list.loading"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import TeamMembersForm from './TeamMembersForm.vue';
import TeamMembersList from './TeamMembersList.vue';

export default {
    props: {
        team_id: { type: Number, default: null },
        show_title: { type: Boolean, default: true },
    },
    components: { TeamMembersList, TeamMembersForm },
    computed: mapState('team_members', ['list']),
    created() {
        this.reload();
    },
    methods: {
        reload() {
            this.$store.dispatch('team_members/list', { team: this.team_id });
        },
    },
};
</script>

<style scoped>
    .members { min-height: 250px;}
</style>
